import { TournamentState } from '@ps/poker-games-tile-mappers';
import type { TranslationTag } from '@ps/web-shared-components';

import { TournamentStateTranslations } from '../../../../../../utils/games';

import styles from './State.scss';
import { TXTCLI_Late_Registration } from './stateData.messages.json';

interface StateData {
  state: TournamentState;
  style: string;
  flagStyle: string;
  translation?: TranslationTag;
}

type DefaultStateData = Omit<StateData, 'state'> & {
  state: string;
};

type StateDataMap = Partial<{
  [K in TournamentState]: StateData;
}> & {
  default: DefaultStateData;
};

export const STATE_DATA_MAP: StateDataMap = {
  [TournamentState.COMPLETED]: {
    state: TournamentState.COMPLETED,
    style: styles.completed,
    flagStyle: styles.flagCompleted,
    translation: TournamentStateTranslations.COMPLETED
  },
  [TournamentState.REGISTERING]: {
    state: TournamentState.REGISTERING,
    style: styles.registering,
    flagStyle: styles.flagRegistering,
    translation: TournamentStateTranslations.REGISTERING
  },
  [TournamentState.ANNOUNCED]: {
    state: TournamentState.ANNOUNCED,
    style: styles.announced,
    flagStyle: styles.flagAnnounced,
    translation: TournamentStateTranslations.ANNOUNCED
  },
  [TournamentState.LATE_REGISTRATION]: {
    state: TournamentState.LATE_REGISTRATION,
    style: styles.lateRegistration,
    flagStyle: styles.flagLateRegistration,
    translation: TXTCLI_Late_Registration
  },
  [TournamentState.RUNNING]: {
    state: TournamentState.RUNNING,
    style: styles.running,
    flagStyle: styles.flagRunning,
    translation: TournamentStateTranslations.RUNNING
  },
  [TournamentState.SEATING]: {
    state: TournamentState.SEATING,
    style: styles.registering,
    flagStyle: styles.flagRegistering,
    translation: TournamentStateTranslations.SEATING
  },
  [TournamentState.CANCELLED]: {
    state: TournamentState.CANCELLED,
    style: styles.running,
    flagStyle: styles.flagRunning,
    translation: TournamentStateTranslations.CANCELLED
  },
  [TournamentState.PAUSED]: {
    state: TournamentState.PAUSED,
    style: styles.running,
    flagStyle: styles.flagRunning,
    translation: TournamentStateTranslations.PAUSED
  },
  default: { state: '', style: '', flagStyle: '' }
};
